import React, { useEffect, useState } from 'react';
import { getConfigFromParamStore, getConfigFromStroage } from '../../utils/getUrlsFromAws';
import './PolicyPack.css';
import { getApiData } from '../../api/api';
import EnterPassword from './EnterPassword';
import DotsLoader from '../Loader/DotsLoader/DotsLoader';
import AxiosRequest from '../../utils/axios';
import { allowOnlyNumbers, hideHeader, restrictSpecialChars } from '../../utils/helperFunctions';
import AppNavbar from '../AppNavbar/AppNavbar';
import { websiteBanner } from '../../images/images';
import { TextField } from '@material-ui/core';
import { createBase64FromFileUrl } from '../../utils/handleData';
import ViewVideo from './ViewVideo';
import AlertDialogue from '../LinkView/AlertDialogue';
import { eyeClosedIcn, eyeIcn } from '../../images/btnIcons';
import { Button } from 'unified-ui-components-library';
import Error from '../Error/Error';

const axios = new AxiosRequest().getClient()

const PolicyPack = () => {
    const [loading, setLoading] = useState(false);
    const [showPasswordScreen, setShowPasswordScreen] = useState(false);
    const [policyNumber, setPolicyNumber] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [videoUrl, setVideoUrl] = useState('');
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isIncompleteUrl, setIsIncompleteUrl] = useState(false)
    const [alertData, setAlertData] = useState({
        open: false,
        type: "",
        msg: "",
        actions: []
    });


    useEffect(() => {
        localStorage.clear();
        hideHeader();
        const [, txnId] = window.location.search.split('=')
        if(!txnId) {
            setIsIncompleteUrl(true)
        } else {
            getConfig();
        }
    }, []);

    const getConfig = async () => {
        const urlData = getConfigFromStroage();
        if (urlData) {
            // verifyLink();
        } else {
            setLoading(true)
            getConfigFromParamStore()
                .then(() => {
                    // verifyLink();
                })
                .catch((err) => {
                    console.log("Error in fetching config--POLICY PACK :: ", err);
                    setLoading(false);
                }).finally(() => {
                    setLoading(false);
                });
        }
    }

    const verifyLink = async () => {
        const [, txnId] = window.location.search.split('=')
        const { url, body } = getApiData("verifyUser");
        body.request.payload.posvRefNumber = txnId;
        body.request.payload.purpose = "policyPack";
        body.request.payload.enteredPolicyNo = policyNumber;
        body.request.payload.policyPackVvPassword = password;
        console.log({ body })
        try {
            setLoading(true)
            const response = await axios.post(url, body);
            console.log({ response })
            if (response?.data?.response?.msgInfo?.msgCode === "200" && response?.data?.response?.payload?.videoPreSignedUrl) {
                const video_url = await createBase64FromFileUrl(response?.data?.response?.payload?.videoPreSignedUrl)
                setVideoUrl(video_url.objUrl)
                setIsLoggedIn(true)
            } else {
                console.log("Error in validating url", response)
                setAlertData({
                    open: true,
                    type: "error",
                    msg: response?.data?.response?.payload?.businessMsg ?? "Something went wrong!",
                    actions: []
                })
            }
        } catch (error) {
            console.log({ error })
            setAlertData({
                open: true,
                type: "error",
                msg: "Something went wrong. Please try again later.",
                actions: []
            })
        } finally {
            setLoading(false)
        }
    };

    const getVideoUrl = async () => {
        const { url, body } = getApiData("policySearch");
        // body.request.payload.posvRefNumber = localStorage.getItem("posvRefNumber");
        body.request.payload.policyNumber = policyNumber;
        body.request.payload.password = password;
        body.request.payload.policyPackVideo = "Y";
        body.request.payload.fromOsp = false;
        body.request.payload.policyStatus = false;
        console.log({ body })
        try {
            setLoading(true)
            const response = await axios.post(url, body);
            console.log({ response })
            if (response?.data?.response?.msgInfo?.msgCode === "200" && response?.data?.response?.payload?.videoPresignedUrl) {
                const video_url = await createBase64FromFileUrl(response?.data?.response?.payload?.videoPresignedUrl)
                setVideoUrl(video_url.objUrl)
                setIsLoggedIn(true)
            } else {
                console.log("Error in validating url", response)
                setAlertData({
                    open: true,
                    type: "error",
                    msg: response?.data?.response?.payload?.businessMsg,
                    actions: []
                })
            }
        } catch (error) {
            console.log({ error })
            setAlertData({
                open: true,
                type: "error",
                msg: "Something went wrong. Please try again later.",
                actions: []
            })
        } finally {
            setLoading(false)
        }
    };

    const handleLogout = () => {
        console.log("Logout")
        setAlertData({
            open: true,
            type: "actionDialog",
            msg: "Are you sure you want to logout of the verification page?",
            actions: [
                {
                    actionText: "Yes,Logout",
                    action: () => {
                        setIsLoggedIn(false);
                        setVideoUrl("");
                        setPolicyNumber("");
                        setPassword("");
                        setAlertData({
                            open: false,
                            type: "",
                            msg: "",
                            actions: [],
                        });
                    },
                    className: "secondaryBtn"
                },
                {
                    actionText: "No",
                    action: () => {
                        setAlertData({
                            open: false,
                            type: "",
                            msg: "",
                            actions: [],
                        });
                    },
                    className: "primaryBtn"
                }
            ]
        })
    }

    const handlePolicyNumber = (e) => {
        const value = e.target.value;
        if ((value === "" || Number(value)) && value.length <= 10) {
            setPolicyNumber(value)
        }
    }

    const handlePassword = (e) => {
        const value = e.target.value;
        if (value.length <= 8) {
            setPassword(value)
        }
    }

    if (isIncompleteUrl) {
        return (
            <>
                <AppNavbar isLoggedIn={isLoggedIn} handleLogout={handleLogout} />
                <Error errorMsg="Invalid Link" />
            </>
        )
    }

    if (videoUrl) {
        return (
            <>
                <AppNavbar isLoggedIn={isLoggedIn} handleLogout={handleLogout} />
                {alertData.open && <AlertDialogue msg={alertData.msg} actions={alertData.actions} type={alertData.type} closeDialogue={
                    () => setAlertData({
                        actions:[],
                        msg:"",
                        open:false,
                        type: ""
                    })
                } />}
                <ViewVideo videoUrl={videoUrl} />
            </>
        )
    }

    return (
        <>
            <AppNavbar />
            {/* {showPasswordScreen && (
                <EnterPassword getVideoUrl={getVideoUrl} />
            )} */}
            {alertData.open && <AlertDialogue msg={alertData.msg} actions={alertData.actions} type={alertData.type} closeDialogue={
                    () => setAlertData({
                        actions:[],
                        msg:"",
                        open:false,
                        type: ""
                    })
                } />}
            <div className='policy_pack_cntnr'>
            {loading && <DotsLoader msg={"Please wait..."} />}
                <div className='policy_pack_form'>
                    <div className='policy_pack_heading'>
                        <h3>View your video verifications</h3>
                        <p>To view, enter policy number and password. The video is viewable for 30 days after your policy is issued.</p>
                    </div>
                    <div className='pp-from'>
                        <TextField
                            id="policyNum"
                            label="Policy Number"
                            type="text"
                            className="new-ui-txt-field"
                            autoComplete="off"
                            variant="outlined"
                            fullWidth
                            value={policyNumber}
                            onChange={handlePolicyNumber}
                            onKeyDown={allowOnlyNumbers}
                        />
                        <div className='pp-password-wrpr'>
                            <TextField
                                id="password"
                                label="Password"
                                type={showPassword ? "text" : "password"}
                                className="new-ui-txt-field"
                                autoComplete="off"
                                variant="outlined"
                                fullWidth
                                value={password}
                                onChange={handlePassword}
                                onKeyDown={restrictSpecialChars}
                            />
                            <img onClick={() => setShowPassword(prev => (!prev)) } src={showPassword ? eyeIcn : eyeClosedIcn} alt='eye_icon' />
                        </div>
                        <ul>
                            <li>Password format: First two letters of policyholder's name + DDMM (birthday)+ last two digit of birth year </li>
                            <li>Example: For Harshwardhan, born July 19, 1992</li>
                            <li>Password would be: HA190792</li>
                        </ul>
                        <div className='button_div_unified'>
                            <Button
                                onClick={verifyLink}
                                className='pp-submit-btn'
                                buttonType='primary'
                            >
                                View Audio Video File
                            </Button>
                        </div>
                    </div>

                </div>
                <div className='policy_pack_banner'>
                    <img src={websiteBanner} alt="Banner" />
                </div>
            </div>
        </>
    );
};

export default PolicyPack;